/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Grid, TextField } from '@material-ui/core';
import { Button } from 'react-bootstrap';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import { RequestQuarterlyClaimReconciliationTableHead } from './TableHead';
import {
  getRequestScreenGrid,
  getTableHeaderGrid,
  selectedRequest,
  getLastUpdatedUseridAndCount,
  getQuarterlyClaimsReconciliationShedule,
  setScheduleMessage,
  setLastUpdatedUseridAndCount,
  setSearchInput,
} from '../Store/actions';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import {
  autoFormateDate,
  getCurrentDate,
  tabHighLigther,
  validateQuarter,
} from '../../../../SharedModules/utilities/utilities';

import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import Fieldset from '../../../../SharedModules/Fieldset/Fieldset';

import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';
import { isReadOnly as isRead, checkActionAccessByRole } from '../../../../SharedModules/utilities/utilities';


const QuarterlyClaimReconcilliationRequest = (props) => {
  const dispatch = useDispatch();
    const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);
    
    const hasRole = (role) =>
        kcRoles?.userPrivileges?.some((r) => r === role) || false;
    
    const disableOtherButtons =
      hasRole('State Employee');
     
  const {
    errors,
    isLoading,
    selectedOption: selectedOptionValue,
    screenGridData,
    qtr: qtrValue,
    headerGridData,
    leftGridData: leftGridDataValue,
    rightGridData: rightGridDataValue,
    lasUpdatedUserIdAndCount,
    scheduleMessage,
  } = useSelector(
    (state) => state?.sharedState?.QuarterlyClaimsReconcilliationReducer
  );

  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );

  const [qtr, setQtr] = React.useState(qtrValue);

  const [radioList, setRadioList] = React.useState([
    {
      value: 'Request Running Of Quarterly Report',
      name: 'Request Running Of Quarterly Report',
      id: 'Request Running Of Quarterly Report',
    },
    {
      value: 'Request Display Of Quarterly Report',
      name: 'Request Display Of Quarterly Report',
      id: 'Request Display Of Quarterly Report',
    },
  ]);
  const [selectedOption, setSelectedOption] =
    React.useState(selectedOptionValue);

  const [errorList, setErrorList] = React.useState(errors);
  const [isSearchClicked, setSearchClicked] = React.useState(false);
  const [isScheduleClicked, setScheduleClicked] = React.useState(false);
  const [open, setOpen] = React.useState(false);

  // on scroll default top level
  const handleScrollToEvent = () => {
    window.scrollTo(0, 0);
  };

  React.useEffect(() => {
    if (isSearchClicked) {
      setSearchClicked(false);
      const updateTabs =
        JSON.parse(localStorage.getItem('tabItemsData')) === null
          ? []
          : JSON.parse(localStorage.getItem('tabItemsData'));
      updateTabs.push({
        navTo: '/quarterlyclaimsreconcilliationdetails',
        value: 'Display Quarterly Claims Reconciliation',
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
      if (props?.history) {
        props.history.push({
          pathname: '/quarterlyclaimsreconcilliationdetails',
        });
        dispatch(
          clearReduxForFilterAndSort('/quarterlyclaimsreconcilliationdetails')
        );
      }
    }
  }, [headerGridData]);

  React.useEffect(() => {
    setErrorList(errors);
  }, [errors]);
  const [rows, setRows] = React.useState([]);
  const [fullScreenView, setFullScreenView] = React.useState(false);

  const clearSchedule = () => {
    if (scheduleMessage !== null) {
      dispatch(setScheduleMessage(null));
    }
    if (lasUpdatedUserIdAndCount !== null) {
      dispatch(setLastUpdatedUseridAndCount(null));
    }
  };
  // Function to toggle fullscreen view of table
  const changeFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };

  // Set the table data rows
  React.useEffect(() => {
    setRows(screenGridData);
  }, [screenGridData]);

  React.useEffect(() => {
    handleScrollToEvent();
    dispatch(getRequestScreenGrid());
  }, []);

  // Highlights the tab if any error
  React.useEffect(() => {
    if (errorList.length > 0) {
      tabHighLigther('/quarterlyclaimsreconcilliation', true);
    } else {
      tabHighLigther('/quarterlyclaimsreconcilliation', false);
    }
  }, [JSON.stringify(errorList)]);

  // function to validate Quarter
  const handleOnBlur = (input) => {
    const error = validateQuarter(input, 'quarter', true);
    setErrorList(error);
  };

  const handleScheduleClick = () => {
    const error = validateQuarter(qtr, 'quarter', true);
    setErrorList(error);

    dispatch(
      setSearchInput({
        errors: error,
        selectedOption,
        qtr,
      })
    );
    if (error.length === 0) {
      setScheduleClicked(true);
      dispatch(
        getLastUpdatedUseridAndCount({
          quarter: qtr,
          userName: userDefaults?.userId,
        })
      );
    }
  };

  const handleAction = (input, value) => {
    if (value === undefined || value === 'button') {
      dispatch(
        getQuarterlyClaimsReconciliationShedule({
          userName: userDefaults?.userId,
          quarter: qtr,
          todaysDt: getCurrentDate('MM/DD/YYYY'),
          isOverWrite: input,
        })
      );
    }
  };

  React.useEffect(() => {
    if (
      lasUpdatedUserIdAndCount !== 'NoRequestExist' &&
      lasUpdatedUserIdAndCount !== null &&
      lasUpdatedUserIdAndCount !== 'default'
    ) {
      setOpen(true);
    } else if (
      lasUpdatedUserIdAndCount === 'NoRequestExist' &&
      isScheduleClicked
    ) {
      handleAction('Yes');
    }
    setScheduleClicked(false);
  }, [lasUpdatedUserIdAndCount]);
  // Handle cell click
  const cellClickedListener = (e) => {
    dispatch(
      setSearchInput({
        errors: errorList,
        selectedOption,
        qtr,
      })
    );
    dispatch(selectedRequest(e?.data));
    setSearchClicked(true);
    dispatch(getTableHeaderGrid({ ...e.data, quarter: e?.data?.qtr }));
  };

  const errorMessages = [...new Set(errorList.map((obj) => obj.message))];
  return (
    <div className="tabs-container">
      <Spinner load={isLoading} />

      <CustomSeparator
        parent1="State Reports"
        parent2="Quarterly Claims Reconciliation Report"
      />

      <DisplayErrorMessages errorMessages={errorMessages.map((l) => l)} />
      {scheduleMessage && scheduleMessage.messageAfterInsertOfRecordsInDb && (
        <div className="alert alert-info custom-alert text-left" role="alert">
          {scheduleMessage.messageAfterInsertOfRecordsInDb}
        </div>
      )}

      <div className="tab-body">
        <CommonModal
          open={open}
          data-testid="quarterly-reconcilllitio"
          viewAction
          viewHeader
          className="dialogPanel frr-rightAlignment custom-check dialog-420"
          onOk={() => {
            setOpen(false);

            handleAction('Yes');
          }}
          okTitle="Yes"
          onClose={(value) => {
            handleAction('No', value);
            setOpen(false);
          }}
          closeTitle="No"
          modalTitle="Please Confirm"
          childrenComponent={
            <div>
              <p>{lasUpdatedUserIdAndCount?.overWriteMessage}</p>
            </div>
          }
        />
        {!fullScreenView && (
          <div className="row">
            <div className="col-6 frr-one-col-radio">
              <RadioGroupComponent
                data-testid="quarterReconcillition-plan-type"
                id="filter-plan-by-radio-btn-action"
                labelName="Request Options"
                required
                optionList={radioList || []}
                defaultValue={selectedOption}
                filterAction={(value) => {
                  setSelectedOption(value);
                  clearSchedule();
                  setErrorList([]);
                }}
                className="log-batch-filter-radio frr-checkInvoiceRadio"
              />
            </div>
            {selectedOption === 'Request Running Of Quarterly Report' && (
              <div className="col-4">
                <Fieldset label="Quarter: " required>
                  <div className="form-wrapper p-0 mt-n3">
                    <div className="mui-custom-form input-md field-xl">
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                          <TextField
                            label="From"
                            placeholder=""
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{ maxLength: 10, id: 'From' }}
                            required
                            name="From"
                            id="From"
                            value={qtr}
                            error={
                              errorList.filter(
                                (error) => error.field === 'quarter'
                              )?.length > 0
                                ? 'mandate-fields'
                                : ''
                            }
                            data-testid="quarterlyReconcillation-from-date"
                            helperText={
                              errorList.find(
                                (error) => error.field === 'quarter'
                              )?.message
                            }
                            className="mandate-fields frr-display-hidden-label"
                            onBlur={(e) => {
                              let { value } = e.target;
                              value = autoFormateDate(value);

                              setQtr(value.toUpperCase());
                              handleOnBlur(value);
                            }}
                            onChange={(e) => {
                              clearSchedule();
                              const { value } = e.target;
                              setQtr(value.toUpperCase());
                              setErrorList([
                                ...errorList.filter(
                                  (error) => error.field !== 'quarter'
                                ),
                              ]);
                            }}
                          />
                        </Grid>
                      </Grid>
                    </div>
                  </div>
                </Fieldset>
              </div>
            )}

            {selectedOption === 'Request Running Of Quarterly Report' && (
              <div className="row" style={{ marginTop: 30 }}>
                <div className="btn-wrapper col-12">
                  <Button
                    data-testid="checkAllocation-searchbtnclick"
                    onClick={handleScheduleClick}
                    className="btn btn-success btn-search float-right"
                    disabled={disableOtherButtons}
                  >
                    Schedule
                  </Button>
                </div>
              </div>
            )}
          </div>
        )}

        {selectedOption !== 'Request Running Of Quarterly Report' && (
          <div className="row" style={{ marginTop: 15 }}>
            <div className="unallocated" style={{ width: '100vw' }}>
              <TableGridWithFeatures
                gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
                columnDefs={RequestQuarterlyClaimReconciliationTableHead}
                rowData={rows}
                data-testid="onEditingStopped"
                enterMovesDown
                showResetFilter={false}
                defaultCol={{
                  wrapHeaderText: true,
                  autoHeaderHeight: true,
                }}
                cellClickedListener={cellClickedListener}
                hideTotalCount={false}
                exportFile
                fileName="Quarterly Claim Request Grid"
                fullScreenView={fullScreenView}
                handleFullScreenViewClick={changeFullScreenView}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default QuarterlyClaimReconcilliationRequest;
